import qs from 'qs'
import request from '@/utils/request'

export function getLoginLogList (params) {
  return request.get('/login-logs', { params })
}

export function exportLoginLog (params) {
  return request.get('/login-logs/export', {
    params,
    paramsSerializer: obj => {
      return qs.stringify(obj, { arrayFormat: 'repeat' })
    },
    responseType: 'blob'
  })
}

export function getOperationLogList (params) {
  return request.get('/operation-logs', { params })
}

export function exportOperationLog (params) {
  return request.get('/operation-logs/export', {
    params,
    paramsSerializer: obj => {
      return qs.stringify(obj, { arrayFormat: 'repeat' })
    },
    responseType: 'blob'
  })
}

export function getNetworkDeviceSysLogList (params) {
  return request.get('/network-device-syslogs', { params })
}

export function getNetworkDeviceSyslogTrend (params) {
  return request.get('/network-device-syslogs/trend', { params })
}

export function getSecurityDeviceSyslogList (params) {
  return request.get('/security-device-syslogs', { params })
}

export function getSecurityDeviceSyslogTrend (params) {
  return request.get('/security-device-syslogs/trend', { params })
}

export function getServerSysLogList (params) {
  return request.get('/server-syslogs', { params })
}

export function getServerSyslogTrend (params) {
  return request.get('/server-syslogs/trend', { params })
}

export function getLinuxSyslogList (params) {
  return request.get('/linux-syslogs', { params })
}

export function getLinuxSyslogTrend (params) {
  return request.get('/linux-syslogs/trend', { params })
}

export function getWindowsEventLogList (params) {
  return request.get('/windows-event-logs', { params })
}

export function getWindowsEventLogTrend (params) {
  return request.get('/windows-event-logs/trend', { params })
}

export function getNginxAccessLogList (params) {
  return request.get('/middleware-nginx-access-logs', { params })
}

export function getNginxAccessLogTrend (params) {
  return request.get('/middleware-nginx-access-logs/trend', { params })
}

export function getTomcatAccessLogList (params) {
  return request.get('/middleware-tomcat-access-logs', { params })
}

export function getTomcatAccessLogTrend (params) {
  return request.get('/middleware-tomcat-access-logs/trend', { params })
}

export function getDaMengAuditLogList (params) {
  return request.get('/database-dameng-audit-logs', { params })
}

export function getDaMengAuditLogTrend (params) {
  return request.get('/database-dameng-audit-logs/trend', { params })
}

export function getServiceCriticalLogList (params) {
  return request.get('/service-critical-logs', { params })
}

export function getServiceCriticalTrend (params) {
  return request.get('/service-critical-logs/trend', { params })
}

export function getServiceStatisticLogList (params) {
  return request.get('/service-statistic-logs', { params })
}

export function getServiceStatisticTrend (params) {
  return request.get('/service-statistic-logs/trend', { params })
}

export function getService3rdLogList (params) {
  return request.get('/service-3rd-interface-logs', { params })
}

export function getService3rdTrend (params) {
  return request.get('/service-3rd-interface-logs/trend', { params })
}

export function getDataExchangeLogList (params) {
  return request.get('/data-exchange-logs', { params })
}

export function getDataExchangeTrend (params) {
  return request.get('/data-exchange-logs/trend', { params })
}
